import { createPosthogClient, identifyFromJwtCookie, POSTHOG_KEY } from '@ramp106/omrjs-core-ui/posthog'
import * as Sentry from '@sentry/vue'

import { env } from '@/config/env'

const MYOMR_SESSION_COOKIE = 'myomr.auth'

function hasMyomrSession(): boolean {
  return document.cookie.split('; ').some((cookie) => cookie.startsWith(`${MYOMR_SESSION_COOKIE}=`))
}

export const ph = createPosthogClient({
  key: env === 'production' ? POSTHOG_KEY.PRODUCTION : POSTHOG_KEY.STAGING,
  identify: () => identifyFromJwtCookie(MYOMR_SESSION_COOKIE),
  getHasConsent: hasMyomrSession,
  sessionRecording: false,
})

let resolvePosthogReady!: () => void
export const posthogReady = new Promise<void>((resolve) => {
  resolvePosthogReady = resolve
})

// The product's company only travels with the flags request, so it is never stored on the person. Its own
// key keeps identify()'s viewer company_slug, which posthog-js copies into the same flag properties, apart.
export function setFeatureFlagProductCompany(companySlug: string | null | undefined): void {
  void posthogReady.then(() => {
    ph.Posthog.setPersonPropertiesForFlags({ product_company_slug: companySlug || null })
  })
}

// The selected partner company also travels only with the flags request, so a flag can target exhibitors.
// It is the slug, not the id: every staging import recreates the sales demo company with a new id.
// Switching the company reloads the page, so it is set once per page load.
export function setFeatureFlagPartnerCompany(partnerCompanySlug: string | null | undefined): void {
  void posthogReady.then(() => {
    ph.Posthog.setPersonPropertiesForFlags({ partner_company_slug: partnerCompanySlug || null })
  })
}

export function initPosthog(): void {
  if (typeof window === 'undefined') return

  void ph
    .init()
    .catch((error: unknown) => Sentry.captureException(error))
    .finally(resolvePosthogReady)
}
